import { render } from "./workDetails.vue?vue&type=template&id=d44f39c0"
import script from "./workDetails.vue?vue&type=script&lang=js"
export * from "./workDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__